import { DataGrid } from "@mui/x-data-grid";
import { observer } from "mobx-react-lite";
import { orderStorage } from "../../services/shop/OrderStorage";
import React from "react";
import "./OrderTable.scss";
import { Table, TableBody, TableCell, TableHead, TableRow, Typography } from "@mui/material";
import { translationService } from "../../services/translation/TranslationService";

// List price of each service per inspection video, shown under the order table.
const SERVICE_PRICES = [
  { key: "shop.activity-prices.notes.ocr", euros: 12 },
  { key: "shop.activity-prices.notes.analysis", euros: 12 },
  { key: "shop.activity-prices.notes.highlighting", euros: 6 },
];

export default observer(function OrderTable() {
  return (
    <div className="base-data-table">
      <Typography variant="caption" sx={{ mb: 1, fontWeight: 500 }}>
        {translationService.translate("shop.activity-prices.table-name")}
      </Typography>
      <DataGrid
        columns={orderStorage.columns}
        rows={orderStorage.rows}
        rowHeight={40}
        hideFooter
        disableColumnMenu
        disableRowSelectionOnClick
      />
      <div className="order-price-notes">
        <Typography variant="caption" component="div" sx={{ fontWeight: 500 }}>
          {translationService.translate("shop.activity-prices.notes.title")}
        </Typography>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>{translationService.translate("shop.activity-prices.notes.service")}</TableCell>
              <TableCell align="right">{translationService.translate("shop.activity-prices.notes.price")}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {SERVICE_PRICES.map((service) => (
              <TableRow key={service.key}>
                <TableCell>{translationService.translate(service.key)}</TableCell>
                <TableCell align="right">{service.euros} €</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </div>
  );
});
